import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`North Eastern Nigeria`}</h3>
    <p>{`Conflict had a devastating impact on the lives and livelihoods in North Eastern Nigeria. Nearly 2 million people were displaced and almost 3 million Nigerians were facing hunger in 2019. With support from donors like the EU, WFP was able to reach nearly `}<a parentName="p" {...{
        "href": "https://www.wfp.org/operations/annual-country-report/?operation_id=NG01&year=2019#/16260"
      }}>{`900,000`}</a>{` people every month in the northeast of the country with food or cash assistance. Pregnant and breastfeeding women as well as children under the age of five also received specialised treatment to prevent and address malnutrition.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      